import React from "react"

const IntlContext = React.createContext({
  defaultValue: "something is wrong! you should not see this",
})

export default IntlContext
